import { IsNullOrEmpty } from "./str.helper";
export class ScriptHelper {
    static isSupervisedEnv(currentEnv, supervisedEnvList = null) {
        const listEnv = supervisedEnvList !== null && supervisedEnvList !== void 0 ? supervisedEnvList : ScriptHelper.supervisedEnv;
        return listEnv.some(x => x.toLocaleLowerCase() === (currentEnv !== null && currentEnv !== void 0 ? currentEnv : '').toLocaleLowerCase());
    }
    static addScriptOnSupervisedEnv(scriptSrc, currentEnv, supervisedEnvList = null, isInnerContent = false, domain = null) {
        if (!IsNullOrEmpty(scriptSrc) &&
            !IsNullOrEmpty(currentEnv) &&
            ScriptHelper.isSupervisedEnv(currentEnv, supervisedEnvList)) {
            return ScriptHelper.addScript(scriptSrc, isInnerContent, domain);
        }
        return false;
    }
    static addScript(scriptSrc, isInnerContent = false, domain = null) {
        if (IsNullOrEmpty(scriptSrc)) {
            return false;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        if (isInnerContent) {
            script.innerHTML = scriptSrc;
        }
        else {
            script.src = scriptSrc;
        }
        script.setAttribute('crossorigin', 'anonymous');
        if (domain) {
            script.setAttribute('data-domain-script', domain);
        }
        document.head.appendChild(script);
        return true;
    }
}
ScriptHelper.supervisedEnv = ['prod', 'production'];
